import { useState, useEffect } from 'react';

// Mobile breakpoint shared across the app. Keep in sync with the
// `@media (max-width: 768px)` block in src/index.css.
export const MOBILE_BREAKPOINT = 768;

/**
 * Returns true when the viewport is at or below the mobile breakpoint.
 * Used to switch desktop tables to mobile card layouts. Desktop rendering
 * (>768px) is left completely untouched.
 */
const useIsMobile = (breakpoint = MOBILE_BREAKPOINT) => {
  const query = `(max-width: ${breakpoint}px)`;

  const getMatch = () =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia(query).matches
      : false;

  const [isMobile, setIsMobile] = useState(getMatch);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return undefined;
    }
    const mql = window.matchMedia(query);
    const handler = (e) => setIsMobile(e.matches);

    // Sync immediately in case the viewport changed before the listener attached.
    setIsMobile(mql.matches);

    // addEventListener is the modern API; addListener is the Safari/old fallback.
    if (mql.addEventListener) {
      mql.addEventListener('change', handler);
      return () => mql.removeEventListener('change', handler);
    }
    mql.addListener(handler);
    return () => mql.removeListener(handler);
  }, [query]);

  return isMobile;
};

export default useIsMobile;
